import { dropdownResponse } from './dropdownResponse'

export const checkDropdownResponse = response => {
  if (!response.data.eventMessage.itemList) {
    return dropdownResponse
  }
  return response
}

export const checkEntrySummaryResponse = response => {
  if (!response.data || !response.data.eventMessage || response.data.code === 400) {
    return false
  } else return response
}
